<template>
    <div id="main-wrapper" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
        <NavbarDark/>

        <BannerOne v-if="data" :item="data.gallery"/>
        <section class="gray-simple">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-md-12 col-sm-12">
                        <div class="agency agency-list overlio-40">
                            <div class="agency-avatar">
                                <img :src="data && data.profile_image" alt="">
                            </div>
                            
                            <div class="agency-content">
                                <div class="agency-name">
                                    <h4>{{data && data.name ? data?.name : 'Unknown'}}</h4>
                                    <span><i class="fa-solid fa-location-dot"></i> {{ data && data.state?.name }} -{{ data && data.city?.name }}</span>
                                </div>
                                
                                <div class="agency-desc">
                                    <p>{{ data && data.about}}</p>
                                </div>
                                
                                <div class="prt-detios">
                                    <span class="label text-light bg-success">{{ data && data.category?.name }}</span>
                                </div>
                                <ul v-if="data" class="social-icons mt-4">
                                    <li>
                                        <a
                                        class="facebook"
                                        :href="data.facebook"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >
                                        <i class="fa-brands fa-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                        class="instagram"
                                        :href="data.instagram"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >
                                        <i class="fa-brands fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                        class="whatsapp"
                                        :href="`https://wa.me/${data.whatsapp}`"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >
                                        <i class="fa-brands fa-whatsapp"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                        class="telegram"
                                        :href="`https://t.me/${data.telegram}`"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >
                                        <i class="fa-brands fa-telegram"></i>
                                        </a>
                                    </li>
                                </ul>
                                <div class="clearfix"></div>
                            </div>
                            <div class="views-count">
                                <span class="label text-light bg-success"><i class="fa-regular fa-eye px-2"></i>{{ data && data.views_count ? data.views_count : '0' }}</span>
                            </div>
                        </div>
                        
                        <PropertyDetail v-if="data" :item="data" />
                    </div>
                    
                    <div class="col-lg-4 col-md-12 col-sm-12">
                        <DetailSidebar v-if="data" :item="data"/>
                    </div>
                </div>
            </div>
        </section>

        <FooterTop :bg="'theme-bg'"/>
        <FooterDark/>
        <ScrollToTop/>
    </div>
</template>

<script setup>
import { ref, onMounted,watch } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import BannerOne from '@/components/banner-one.vue'
import NavbarDark from '@/components/navbar/navbar-dark.vue'
import DetailSidebar from '@/components/property/detail-sidebar.vue'
import FooterTop from '@/components/footer/footer-top.vue'
import FooterDark from '@/components/footer/footer-dark.vue'
import ScrollToTop from '@/components/scroll-to-top.vue'
import PropertyDetail from '@/components/property/property-detail.vue'
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
const route = useRoute()
const data = ref(null)
const loading = ref(true)
const error = ref(null)
const fetchData = async () => {
  loading.value = true
  error.value = null
  try {
    const id = route.params.id

    axios.get(`/increase-views/${id}`)

    const response = await axios.get(`/service-provider/show-details-by-id/${id}`, {
        headers: {
            'locale': locale.value   
        }
    })
    data.value = response.data.service_provider_details

  } catch (err) {
    console.error('Error fetching service provider details:', err)
    error.value = err
  } finally {
    loading.value = false
  }
}
onMounted(() => {
  fetchData()
})
watch(locale, () => {
  fetchData()
})
</script>
<style scoped>
.views-count {
    display: flex;
    gap: 5px;
    font-size: 20px;
    color: #555;
    height: 30px;
   
}
[dir="rtl"] .views-count {
 padding-right: 19px;
}
[dir="ltr"] .views-count {
 padding-left: 17px;
}
</style>
